import { render, staticRenderFns } from "./CardWebsiteStatistics.vue?vue&type=template&id=06893210&scoped=true&"
import script from "./CardWebsiteStatistics.vue?vue&type=script&lang=js&"
export * from "./CardWebsiteStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CardWebsiteStatistics.vue?vue&type=style&index=0&id=06893210&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06893210",
  null
  
)

export default component.exports